import { inject } from "@angular/core";
import { Router } from "@angular/router";

import RouteNameConstants from "../constants/route-name-constants";
import { TechCoverVisibilityService } from "../services/tech-cover-visibility.service";

export const techCoverGuard = async () => {
  const router = inject(Router);
  const techCoverVisibilityService = inject(TechCoverVisibilityService);

  const isEnabled = await techCoverVisibilityService.getTechCoverStatusAsync();
  if (!isEnabled) {
    router.navigate([RouteNameConstants.NO_ACCESS]);
    return false;
  }
  return true;
};

// TODO: move other guards here and make them functional too.
